import { AxiosConfigBenchmarking } from "Benchmarking/Config/AxiosConfig";

export const getDepartmentSuggestSearch = (param, callback) => {
  const axios = AxiosConfigBenchmarking();
  const url = `/departments/suggest/${param}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};
